// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.version-mismatch-alert {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-left: 4px solid #ffbc34;
  overflow: hidden;
  display: flex;
  animation: slide-in 0.3s ease-out;
}

.alert-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.alert-icon {
  color: #ffbc34;
  font-size: 24px;
}

.alert-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.alert-message p {
  margin: 0 0 8px;
  font-size: 14px;
  color: #666;
}

.alert-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 18px;
  padding: 4px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 50%;
}
.close-button:hover {
  color: #666;
  background-color: rgba(0, 0, 0, 0.05);
}

@keyframes slide-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
:host-context([data-theme=dark]) .version-mismatch-alert {
  background-color: #2c3e50;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
:host-context([data-theme=dark]) .alert-title {
  color: #eee;
}
:host-context([data-theme=dark]) .alert-message p {
  color: #bbb;
}
:host-context([data-theme=dark]) .close-button {
  color: #bbb;
}
:host-context([data-theme=dark]) .close-button:hover {
  color: #eee;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/version-mismatch-alert/version-mismatch-alert.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0CAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAGE;EACE,eAAA;EACA,eAAA;EACA,WAAA;AAAJ;;AAIA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AADF;AAGE;EACE,WAAA;EACA,qCAAA;AADJ;;AAKA;EACE;IACE,2BAAA;IACA,UAAA;EAFF;EAIA;IACE,wBAAA;IACA,UAAA;EAFF;AACF;AAOE;EACE,yBAAA;EACA,yCAAA;AALJ;AAQE;EACE,WAAA;AANJ;AASE;EACE,WAAA;AAPJ;AAUE;EACE,WAAA;AARJ;AAUI;EACE,WAAA;AARN;AACA,o8GAAo8G","sourcesContent":[".version-mismatch-alert {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n  max-width: 400px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-left: 4px solid #ffbc34;\n  overflow: hidden;\n  display: flex;\n  animation: slide-in 0.3s ease-out;\n}\n\n.alert-content {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.alert-icon {\n  color: #ffbc34;\n  font-size: 24px;\n}\n\n.alert-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.alert-message {\n  p {\n    margin: 0 0 8px;\n    font-size: 14px;\n    color: #666;\n  }\n}\n\n.alert-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 4px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  border-radius: 50%;\n\n  &:hover {\n    color: #666;\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n}\n\n@keyframes slide-in {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n// Dark mode styles\n:host-context([data-theme=\"dark\"]) {\n  .version-mismatch-alert {\n    background-color: #2c3e50;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  }\n\n  .alert-title {\n    color: #eee;\n  }\n\n  .alert-message p {\n    color: #bbb;\n  }\n\n  .close-button {\n    color: #bbb;\n\n    &:hover {\n      color: #eee;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
